const routes = [{
  path: '/feiche/program',
  component: () => import('@/views/feiche/program'),
  name: 'feiche-program',
  meta: {
    title: '项目管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/program.js